import { UserGroup } from '../../../users/user';
import { UserService } from '../../../users/user.service';
import { ILink } from './link.interface';


const links = {
  build(userService: UserService): ILink[] {
    return [
      {
        text: 'Home',
        route: '/usan',
        iconName: 'home',
        isAuthorizedToView: profileCheckers.isLoggedIn(userService, UserGroup.Admin),
        unlockCase: true,
        isExternalLink: false,
        isFooterLink: true,
        tooltipText: 'Home',
      },
      {
        text: 'Naming Guidelines',
        route: '/naming-guidelines',
        iconName: 'science',
        isAuthorizedToView: profileCheckers.isLoggedIn(userService, UserGroup.Admin),
        unlockCase: false,
        isExternalLink: true,
        isFooterLink: true,
        tooltipText: 'Naming Guidelines',
        externalUrl: 'https://www.ama-assn.org/about/united-states-adopted-names/united-states-adopted-names-naming-guidelines',
      },
      {
        text: 'Procedure Overview',
        route: '/procedure-overview',
        iconName: 'assignment',
        isAuthorizedToView: profileCheckers.isLoggedIn(userService, UserGroup.Admin),
        unlockCase: false,
        isExternalLink: true,
        isFooterLink: true,
        tooltipText: 'Procedure Overview',
        externalUrl: 'https://www.ama-assn.org/about/united-states-adopted-names/procedure-usan-name-selection',
      },
      {
        text: 'Drug Finder',
        route: '/drug-finder',
        iconName: 'medication',
        isAuthorizedToView: profileCheckers.isLoggedIn(userService, UserGroup.Admin),
        unlockCase: false,
        isExternalLink: true,
        isFooterLink: false,
        tooltipText: 'Drug Finder',
        externalUrl: 'https://searchusan.ama-assn.org/finder/usan/search/*/relevant/1'
      },
      {
        text: 'Approved Stems',
        route: '/approved-stems',
        iconName: 'done_outline',
        isAuthorizedToView: profileCheckers.isLoggedIn(userService, UserGroup.Admin),
        unlockCase: false,
        isExternalLink: true,
        isFooterLink: false,
        tooltipText: 'Approved Stems',
        externalUrl: 'https://www.ama-assn.org/about/united-states-adopted-names/united-states-adopted-names-approved-stems',
      },
      {
        text: 'Under Consideration',
        route: '/under-consideration',
        iconName: 'construction',
        isAuthorizedToView: profileCheckers.isLoggedIn(userService, UserGroup.Admin),
        unlockCase: false,
        isExternalLink: true,
        isFooterLink: false,
        tooltipText: 'Under Consideration',
        externalUrl: 'https://www.ama-assn.org/about/united-states-adopted-names/usan-drug-names-under-consideration',
      },
      {
        text: 'About USAN Council',
        route: '/about',
        iconName: 'description',
        isAuthorizedToView: profileCheckers.isLoggedIn(userService, UserGroup.Admin),
        unlockCase: false,
        isExternalLink: true,
        isFooterLink: false,
        tooltipText: 'About USAN Council',
        externalUrl: 'https://www.ama-assn.org/about/united-states-adopted-names/usan-council',
      },
      {
        text: 'FAQS',
        route: '/faqs',
        iconName: 'question_mark',
        isAuthorizedToView: profileCheckers.isLoggedIn(userService, UserGroup.Admin),
        unlockCase: false,
        isExternalLink: true,
        isFooterLink: true,
        tooltipText: 'FAQS',
        externalUrl: 'https://www.ama-assn.org/about/united-states-adopted-names/united-states-adopted-names-faq',
      },
        {
        text: 'Contact USAN',
        route: '/contactusan',
        iconName: 'support_agent',
        isAuthorizedToView: profileCheckers.isLoggedIn(userService, UserGroup.Admin),
        unlockCase: false,
        isExternalLink: true,
        isFooterLink: false,
        tooltipText: 'Contact USAN',
        externalUrl: 'https://www.ama-assn.org/about/united-states-adopted-names-usan/usan-council#usan-program-staff-contacts',
      },
    ];
  }
};

const profileCheckers = {

  isInGroup(userService: UserService, group: string): boolean {
    return userService.isInGroup(group);
  },
  isLoggedIn(userService: UserService, group: string): boolean {
    return userService.isLoggedIn();
  }

};

export default links;
